<template>
  <div class="form-control" :style="colSpan ? `grid-column: span ${colSpan};` : ''">
    <div class="form-control__title text-body-2" v-if="$slots.title">
      <label class="form-control__label"><slot name="title" /></label>
      <span class="form-control__required" v-if="required">*</span>
      <div class="form-control__hint" v-if="$slots.hint">
        <slot name="hint" />
      </div>

      <v-tooltip v-if="$slots.tooltip">
        <template #activator="{ props }">
          <v-icon class="text-secondary" v-bind="props">mdi-information-outline</v-icon>
        </template>

        <slot name="tooltip" />
      </v-tooltip>

      <div class="form-control__append" v-if="$slots.append">
        <slot name="append" />
      </div>
    </div>
    <div class="form-control__content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineSlots<{
  default: any;
  title?: any;
  tooltip?: any;
  hint?: any;
  append?: any;
}>();

defineProps<{
  required?: boolean;
  colSpan?: number;
}>();
</script>

<style lang="scss">
.form-control {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: min-content auto;
  gap: var(--spacing-1);

  &__title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--spacing-1);
    min-height: 24px;

    > .form-control__label {
      font-weight: bold;
    }

    > .form-control__required {
      color: var(--v-error);
    }

    > .form-control__hint {
      font-size: 12px;
      color: var(--v-outline);

      &:before {
        content: '•';
        font-size: 12px;
        margin: 0 var(--spacing-1);
        color: var(--v-outline);
      }
    }

    > .form-control__append {
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      gap: var(--spacing-1);
      flex: 1 1 auto;
      justify-content: space-between;
      margin-left: auto;
    }

    &,
    & .v-icon {
      font-size: 16px;
    }
  }

  &:has(.v-input--disabled),
  &:has(.v-field--disabled) {
    .form-control__title {
      color: var(--v-outline);
    }
  }
}
</style>
